/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-03-02 09:37:28
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-10-15 20:24:41
 * @FilePath: \baishu_react_ui\src\components\BsyAlertTextEdit\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react'
import ReactDOM from 'react-dom'

import Dlg from './dlg'
import {BsyUtils} from '../../utils/Utils'


const BsyAlertTextEdit = props =>
    new Promise((fulfill) => { // 此处参数需用圆括号，否则 eslint 报错
        let holder
        let rootTokenClass = 'rootTokenCls'+ (new Date()).getTime()
        let CleanRootNode = (e)=>{
            // 当界面被点击时自动清理元素
            // e 为null，组件自己清理自己
            // 无法找到父级元素 rootTokenClass 说明点击了其他任意位置
            if(!e || !BsyUtils.closestClass(e.target,rootTokenClass)) {

                holder && holder.classList.remove("fadein");
                setTimeout(()=>{
                    holder && holder.removeEventListener('mouseup', stopProp, false);
                    // holder && ReactDOM.unmountComponentAtNode(holder)
                    holder && holder.remove();
                },60)
                document.removeEventListener('mouseup', CleanRootNode, false);
            }
        }

        holder = document.createElement('div');
        holder.style.zIndex = window.FX.STATIC.zIndex++
        holder.classList.add("BsyAlertTextEdit");
        // eslint-disable-next-line default-case
        holder.classList.add("modal");
        holder.classList.add("dark");
        // holder.classList.add("scrollable");
        holder.classList.add("fadein");
        setTimeout(()=>{
            holder.classList.add("active");
        },30)
        holder.classList.add('rootTokenClass');
        document.body.appendChild(holder)

        let stopProp = (event) =>{
            event.stopPropagation()
        }

        holder && holder.addEventListener('mouseup', stopProp, false);
        const newProps = { ...props }
        newProps.onRemoveRoot = (event)=>{
            event && event.stopPropagation();
            //自动清理
            CleanRootNode();

        }

        holder && ReactDOM.render(
            <Dlg
                {...newProps}
            />,
            holder
        )
    }).catch(res => {
        console.error('BsyAlertTextEdit',res);
    })

export default BsyAlertTextEdit